// extracted by mini-css-extract-plugin
export var hideEditor = "_la-2";
export var infoIcon = "_la-3";
export var label = "_la-1";
export var labelContainer = "_la-0";
export var readonlyText = "_la-4";